import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
    marginBottom: 5,
    backgroundColor: '#F5F5F5'
  },
  header: {
    height: '10%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 1px 3px rgba(36, 55, 143, 0.2)'
  },
  boxheader: {
    width: '70%',
    height: '98%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  img: {
    width: 130,
    height: 30,
    // SMALL MOBILE:
    '@media all and (max-width: 479px)': {
      width: '40%'
    }
  },
  body: {
    width: '100%',
    height: '80%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  boxBody: {
    borderRadius: 2,
    width: '30%',
    border: '1px solid #ccc',
    height: 'calc(70vh - 6rem)',
    position: 'absolute',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    // SCREENS:
    '@media all and (max-width: 1000px)': {
      width: '40%'
    },
    '@media all and (max-width: 850px)': {
      width: '55%'
    },
    '@media all and (max-width: 550px)': {
      width: '80%'
    },

    '@media all and (max-height: 550px)': {
      height: 'calc(80vh - 6rem)'
    },
    // // DESKTOP:
    // '@media all and (min-width: 1199px) and (max-width: 1440px)': {
    //   width: '35%',
    //   height: '60%'
    // },
    // // MEDIUM
    // '@media all and (min-width: 960px) and (max-width: 1199px)': {
    //   width: '35%',
    //   height: '60%'
    // },
    // // TABLETS:
    // '@media all and (min-width: 768px) and (max-width: 959px)': {
    //   width: '50%',
    //   height: '60%'
    // },
    // // BIG MOBILE:
    // '@media all and (min-width: 480px) and (max-width: 767px)': {
    //   width: '80%',
    //   height: '70%'
    // },
    // // SMALL MOBILE:
    // '@media all and (max-width: 479px)': {
    //   width: '80%',
    //   height: '50%'
    // },
    // boxShadow: '0px 1px 83px -22px rgba(145,141,141,0.74)',
    // WebkitBoxShadow: '0px 1px 83px -22px rgba(145,141,141,0.74)',
    // MozBoxShadow: '0px 1px 83px -22px rgba(145,141,141,0.74)',
    backgroundColor: '#F5F5F5'
  },
  imgErreparBox: {
    position: 'absolute',
    marginBottom: 'calc(70vh - 6rem)',
    zIndex: 2,
    '@media all and (max-height: 550px)': {
      marginBottom: 'calc(80vh - 6rem)'
    }
  },
  imgErrepar: {
    width: 60,
    height: 60,
    padding: 4,
    background: '#F5F5F5',
    '@media all and (max-height: 550px)': {
      width: 50,
      height: 50
    },
    '@media all and (max-width: 350px)': {
      width: 50,
      height: 50
    }
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'center'
  },
  boxsubtitle: {
    color: '#696B69',
    paddingTop: '1.5rem'
  },
  title: {
    textAlign: 'center',
    color: '#262323',
    fontWeight: 'bold',
    fontSize: '1.7rem',
    fontFamily: 'roboto',
    '@media all and (max-width: 450px)': {
      fontSize: '1.4rem'
    },
    '@media all and (max-height: 550px)': {
      fontSize: '1.4rem'
    },
    '@media all and (max-width: 350px)': {
      fontSize: '1rem'
    }
  },
  subTitle: {
    textAlign: 'center',
    fontSize: '1rem',
    fontFamily: 'roboto',
    '@media all and (max-width: 450px)': {
      fontSize: '0.9rem'
    },
    '@media all and (max-height: 550px)': {
      fontSize: '0.9rem'
    },
    '@media all and (max-width: 350px)': {
      fontSize: '0.7rem'
    }
  },
  subTitleBold: {
    textAlign: 'center',
    fontSize: '1rem',
    fontFamily: 'roboto',
    fontWeight: 'bold',
    '@media all and (max-width: 450px)': {
      fontSize: '0.9rem'
    },
    '@media all and (max-height: 550px)': {
      fontSize: '0.9rem'
    },
    '@media all and (max-width: 350px)': {
      fontSize: '0.7rem'
    }
  },
  boxButtonLogin: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '5rem'
  },
  buttonLogin: {
    width: '80%',
    background: 'linear-gradient(90deg, #00A88F 0%, #5ec498 99.84%)',
    backgroundColor: '#04BFAD',
    color: '#ffff',
    boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)',
    borderRadius: '23px',
    '@media all and (max-height: 550px)': {
      width: '60%'
    },
    '@media all and (max-width: 300px)': {
      fontSize: '0.7rem'
    }
  },
  footer: {
    height: '10%',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px -1px 3px rgba(36, 55, 143, 0.2)',
    backgroundColor: '#F5F5F5'
  },
  loginContainer: {
    width: '100%',
    paddingTop: 10
  }
}))

export default useStyles
